import { CellType, HeadCell } from '@dfl/mui-admin-layout';
import { FormattedAddressCell } from 'components/AddressCell';

export const dateColumn: HeadCell<any> = {
  field: 'createdAt',
  type: CellType.DATE,
  headerName: 'common:date',
  width: 180,
};

export const createdATColumn: HeadCell<any> = {
  field: 'createdAt',
  type: CellType.DATE,
  headerName: 'common:createdAt',
  width: 180,
};

export const addressColumn: HeadCell<any> = {
  field: 'address',
  translate: true,
  headerName: 'common:address',
  width: 350,
  renderCell: (name: string, data: any) => <FormattedAddressCell address={data.address} />,
};

export const emailColumn: HeadCell = {
  sortable: false,
  field: 'email',
  type: CellType.EMAIL,
  headerName: 'common:email',
};

export const phoneColumn: HeadCell = {
  sortable: false,
  field: 'phone',
  type: CellType.PHONE,
  headerName: 'common:phone',
};
